export default {
    CMS_DATA: "CMS_DATA",
    SDK_CONFIG: "SDK_CONFIG",
    CUSTOMER_EXISTS: "CUSTOMER_EXISTS",
    CUSTOMER_DATA: "CUSTOMER_DATA",
    CONFIRM_INTENT_DATA: "CONFIRM_INTENT_DATA",
    PAID_HEALTH_QUOTE: "PAID_HEALTH_QUOTE",
};
